import React, { useState } from "react";

export default function AppTextarea({
  size = "md",
  invalid = false,
  className = "",
  value,
  defaultValue = "",
  onChange,
  disabled = false,
  readOnly = false,
  rows = 4,
  resize = "vertical",
  placeholder = "",
  ...props
}) {
  const isControlled = value !== undefined;
  const [internalValue, setInternalValue] = useState(defaultValue);
  const currentValue = isControlled ? value : internalValue;

  const classes = [
    "ds-textarea",
    size === "sm" ? "ds-textarea--sm" : "",
    size === "md" ? "ds-textarea--md" : "",
    invalid ? "ds-control--invalid" : "",
    resize === "none" ? "ds-textarea--resize-none" : "",
    resize === "both" ? "ds-textarea--resize-both" : "",
    resize === "horizontal" ? "ds-textarea--resize-horizontal" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  function handleChange(event) {
    if (!isControlled) {
      setInternalValue(event.target.value);
    }
    if (onChange) {
      onChange(event);
    }
  }

  return (
    <textarea
      className={classes}
      value={currentValue ?? ""}
      disabled={disabled}
      readOnly={readOnly}
      rows={rows}
      placeholder={placeholder}
      aria-invalid={invalid ? "true" : undefined}
      onChange={handleChange}
      {...props}
    />
  );
}
